// extracted by mini-css-extract-plugin
export default {"InfoButton":"InfoButton_InfoButton__nmqOu"};